export default __webpack_public_path__ + "static/DocUpBlack-f9e9562deb9bdfa02036f7dfb51322b8.png";